// OAuth configuration - only included if domain is configured
const oauthConfig = process.env.REACT_APP_AUTH_DOMAIN
  ? {
      oauth: {
        domain: process.env.REACT_APP_AUTH_DOMAIN,
        scope: ['email', 'openid', 'profile'],
        redirectSignIn:
          process.env.REACT_APP_REDIRECT_SIGN_IN || window.location.origin + '/dashboard',
        redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT || window.location.origin + '/',
        responseType: 'code',
      },
    }
  : {};

export const AwsCognitoConfig = {
  region: process.env.REACT_APP_AUTH_REGION,
  userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID,
  mandatorySignIn: false,
  authenticationFlowType: 'USER_SRP_AUTH',
  signUpVerificationMethod: 'code',
  ...oauthConfig,
};
